import React, { useEffect, useState } from 'react'
import Header3 from '../../../Layout/Header3'
import PropertyPageBanner from './PropertyPageBanner'
import PropertyLocation from './PropertyLocation'
import HomeService from '../../../Services/HomeService';
import { WinnersBannerBlue } from '../WinnerBlueLan/WinnerBannerBlue';
import { WinnersHeaderBlue } from '../WinnerBlueLan/WinnersHeaderBlue';


function NewPropertySingle() {
   const [property, setProperty] = useState({});

  const fetchPropertyById = async () => {
    try {

      const res = await HomeService.getPropertyById(
        localStorage.getItem("propertyId")
      );

      console.log("Property Details", res);

      if (res?.status) {
        setProperty(res?.data);
      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPropertyById();
  }, []);

 
  return (
    <div>
        {/* <Header3/> */}
        <WinnersHeaderBlue/>
           <PropertyPageBanner property={property} />

            <PropertyLocation property={property}  />
        
    </div>
  )
}

export default NewPropertySingle